"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
var _check = _interopRequireDefault(require("../../icons/check"));
var _inputValidationMessage = _interopRequireWildcard(require("../input-validation-message"));
require("./option.css");
var _excluded = ["children", "className", "error", "errorMessage", "type"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Option = exports["default"] = /*#__PURE__*/function (_Component) {
  function Option() {
    _classCallCheck(this, Option);
    return _callSuper(this, Option);
  }
  _inherits(Option, _Component);
  return _createClass(Option, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var checked = this.$input.checked;
      if (checked === undefined || checked === this.props.checked) {
        return;
      }
      if (this.props.onChange) {
        this.props.onChange({
          target: {
            checked: checked,
            name: this.props.name,
            type: this.props.type
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        error = _this$props.error,
        errorMessage = _this$props.errorMessage,
        type = _this$props.type,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var id = this.props.id || (0, _uniqueId2["default"])('option');
      var classList = (0, _classnames["default"])('option', _defineProperty(_defineProperty(_defineProperty({}, className, Boolean(className)), 'option--checkbox', type === 'checkbox'), 'option--radio', type === 'radio'));
      var validationId = "".concat(id, "-validationHint");
      var useAriaDescribedBy = (0, _inputValidationMessage.getDisplayStatus)({
        error: error,
        errorMessage: errorMessage
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
        className: classList
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        "aria-describedby": useAriaDescribedBy ? validationId : null,
        "aria-invalid": error,
        "aria-required": this.props.required,
        className: "option__input hiddenVisually",
        ref: function ref(el) {
          return _this.$input = el;
        },
        type: type
      }, otherProps)), /*#__PURE__*/_react["default"].createElement("span", {
        className: "flex option__label"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "flex-shrink-none"
      }, type === 'checkbox' ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "block option__labelMarker"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        className: "block option__labelIcon",
        path: _check["default"],
        size: "24px"
      })) : /*#__PURE__*/_react["default"].createElement("span", {
        className: "block option__radioIcon"
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "option__labelText"
      }, children))), /*#__PURE__*/_react["default"].createElement(_inputValidationMessage["default"], {
        error: error,
        errorMessage: errorMessage,
        id: validationId
      }));
    }
  }]);
}(_react.Component);
_defineProperty(Option, "defaultProps", {
  type: 'checkbox'
});
Option.propTypes = process.env.NODE_ENV !== "production" ? {
  checked: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  type: _propTypes["default"].string
} : {};